// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__uVN1D","loaderOuter":"PageOverlayLoader_loaderOuter__3w5y3"};